export default __webpack_public_path__ + "static/media/Wrapper3d.cc639633.bin";